import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { CategoriesApiResponse } from '../models/category.model';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private http = inject(HttpClient);

  getProjectCategories(): Observable<CategoriesApiResponse> {
    return this.http.get<CategoriesApiResponse>(`${environment.endpoint}/projects/categories`);
  }

  getServiceCategories(): Observable<CategoriesApiResponse> {
    return this.http.get<CategoriesApiResponse>(`${environment.endpoint}/services/categories`);
  }
}
